module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-11.0a1e80b2.png";